<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="6">
        <div class="text-h5 font-weight-regular">
          Sản Phẩm Nông Nghiệp
        </div>
      </v-col>
      <v-col cols="6">
        <div class="text-right">
          <v-btn text to="/products">
            <span class="primary--text">Xem thêm ❯❯</span>
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col class="text-center">
        <v-btn
          @click="getProductByType('special')"
          class="my-2 mr-4 text-capitalize"
          :class="specialActive ? 'px-16' : ''"
          rounded
          small
          :block="!$vuetify.breakpoint.lgAndUp"
          :color="specialActive ? 'primary' : ''"
          :text-color="specialActive ? 'white' : ''"
        >
          <v-icon v-if="specialActive" left>
            mdi-chevron-right
          </v-icon>
          Sản phẩm đặc sản
        </v-btn>
        <v-btn
          @click="getProductByType('chain')"
          class="my-2 mr-4 text-capitalize"
          :class="chainActive ? 'px-16' : ''"
          rounded
          small
          :block="!$vuetify.breakpoint.lgAndUp"
          :color="chainActive ? 'primary' : ''"
          :text-color="chainActive ? 'white' : ''"
        >
          <v-icon v-if="chainActive" left>
            mdi-chevron-right
          </v-icon>
          Sản phẩm chuỗi
        </v-btn>
        <v-btn
          @click="getProductByType('ocop')"
          class="my-2 text-capitalize"
          :class="ocopActive ? 'px-16' : ''"
          rounded
          small
          :block="!$vuetify.breakpoint.lgAndUp"
          :color="ocopActive ? 'primary' : ''"
          :text-color="ocopActive ? 'white' : ''"
        >
          <v-icon v-if="ocopActive" left>
            mdi-chevron-right
          </v-icon>
          Sản phẩm OCOP
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="loadingProduct" class="mt-8">
      <v-col
        v-for="i in 4"
        :key="i"
        cols="6"
        md="3"
      >
        <v-skeleton-loader
          class="mx-auto"
          type="image, list-item-two-line"
        />
      </v-col>
    </v-row>
    <v-row v-if="chainActive">
      <v-col cols="12" class="product-list">
        <vue-horizontal-list :items="products" :options="options">
          <template v-slot:default="{ item }">
            <v-hover
              v-slot="{ hover }"
            >
              <v-card
                class="mx-auto rounded-lg"
                max-width="400"
                :to="{ name: 'ChainProductTrace', params: { id: item.id }}"
              >
                <v-img
                  class="white--text align-end"
                  height="200px"
                  :src="`${apiBaseUrl}/uploads/${item.logo}`"
                  gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                  :style="{opacity: hover ? '0.8' : 1}"
                >
                  <v-card-title class="text-capitalize text-subtitle-1">
                    <v-chip v-if="item.san_pham" :title="item.san_pham">{{ item.san_pham }}</v-chip>
                  </v-card-title>
                </v-img>
              </v-card>
            </v-hover>
          </template>
        </vue-horizontal-list>
      </v-col>
    </v-row>
    <v-row v-if="ocopActive">
      <v-col cols="12" class="slis">
        <vue-horizontal-list :items="products" :options="options">
          <template v-slot:default="{ item }">
            <v-hover
              v-slot="{ hover }"
            >
              <v-card
                class="mx-auto rounded-lg"
                max-width="400"
                :to="{ name: 'OcopProductTrace', params: { id: item.id }}"
              >
                <v-img
                  class="white--text align-end"
                  height="200px"
                  :src="item.logoBase64 ? item.logoBase64 : require(`@/assets/ocop-logo.png`)"
                  gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                  :style="{opacity: hover ? '0.8' : 1}"
                >
                  <v-card-title class="text-capitalize text-subtitle-1">
                    <v-chip v-if="item.tenSanPham" :title="item.tenSanPham">{{ item.tenSanPham }}</v-chip>
                  </v-card-title>
                </v-img>
              </v-card>
            </v-hover>
          </template>
        </vue-horizontal-list>
      </v-col>
    </v-row>
    <v-row v-if="specialActive">
      <v-col cols="12" class="slis">
        <vue-horizontal-list :items="products" :options="options">
          <template v-slot:default="{ item }">
            <v-hover
              v-slot="{ hover }"
            >
              <v-card
                class="mx-auto rounded-lg"
                max-width="400"
                :to="{ name: 'TreeProductTrace', params: { id: item.id }}"
              >
                <v-img
                  class="white--text align-end"
                  height="200px"
                  :src="item.hinhAnhBase64"
                  gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                  :style="{opacity: hover ? '0.8' : 1}"
                >
                  <v-card-title class="text-capitalize text-subtitle-1"
                    :title="item.tenCayTrong">
                    {{ item.tenCayTrong }}
                  </v-card-title>
                </v-img>
              </v-card>
            </v-hover>
          </template>
        </vue-horizontal-list>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import VueHorizontalList from "vue-horizontal-list";
import { mapState } from 'vuex';
export default {
  name: 'ProductRecent',
  components: {
    VueHorizontalList
  },
  data () {
    return {
      loadingProduct: false,
      products: [],
      hover: false,
      chainActive: false,
      ocopActive: false,
      specialActive: false,
      options: {
        position: {
          start: 1,
        },
        autoplay: {
          play: false,
          speed: 3000,
          repeat: false,
        },
      }
    }
  },
  computed: {
    ...mapState([
      'config'
    ]),
    apiBaseUrl() {
      return this.config.beUrl;
    }
  },
  mounted () {
    this.getSpecialProduct();
  },
  methods: {
    getProducts () {
      this.loadingProduct=true;
      let request = {
        params: {
          per_page: 4
        }
      };
      axios.get("api/v1/public/products", request)
        .then(response => {
          this.products = response.data.data;
          this.loadingProduct=false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getProductByType(type){
      this.chainActive = false;
      this.ocopActive = false;
      this.specialActive = false;
      this.products = [];

      if(type == 'chain'){
        this.getChainProduct();
      } else if (type == 'ocop'){
        this.getOcopProduct();
      } else {
        this.getSpecialProduct();
      }
    },
    getChainProduct () {
      const app = this;
      app.chainActive = true;
      app.loadingProduct = true;
      let request = {
        params: {
          page: 1, 
          per_page: 20
        }
      };
      axios.get("api/v1/public/product-chains", request)
        .then(response => {
          app.products = response.data.data;
          app.loadingProduct=false;
        })
        .catch(function (error) {
          console.log(error);
          app.loadingProduct=false;
        });
    },
    getOcopProduct () {
      const app = this;
      app.ocopActive = true;
      app.loadingProduct=true;
      let request = {
        params: {
          page: 1, 
          size: 20
        }
      };
      axios.get("api/v1/public/get-ocop-products", request)
        .then(response => {
          app.products = response.data.data;
          app.loadingProduct=false;
        })
        .catch(function (error) {
          console.log(error);
          app.loadingProduct=false;
        });
    },
    getSpecialProduct () {
      const app = this;
      app.specialActive = true;
      app.loadingProduct=true;
      let request = {
        params: {
          page: 1, 
          size: 20
        }
      };
      axios.get("api/v1/public/get-tree-special-product", request)
        .then(response => {
          app.products = response.data.data;
          app.loadingProduct=false;
        })
        .catch(function (error) {
          console.log(error);
          app.loadingProduct=false;
        });
    }
  }
}
</script>
<style scoped>
  ::v-deep .v-skeleton-loader__image {
    height: 130px !important;
  }
</style>
